const vowels = ["a", "e", "i", "o", "u"];

export default str => vowels.indexOf(str.toLowerCase()[0]) >= 0;



// WEBPACK FOOTER //
// ./js/helpers/startsWithVowel.js